// extracted by mini-css-extract-plugin
export default {"mCard":"SB-z","image":"TB-z","imageNoBackground":"UB-z","imageHasCategory":"VB-z","fullWidth":"WB-z"};